/**
 * TR-788 responsible-gambling banner documents (tenancy subgraph).
 * RgBanner / RgBannerInput / RgBannerVariant come from codegen (types.ts).
 */
import { gql } from '@apollo/client'

import { RgBanner, RgBannerInput } from './types'

export type GetRgBannerQuery = { rgBanner?: RgBanner | null }
export type GetRgBannerQueryVariables = { countryCode?: string | null }
export type GetRgBannersQuery = { rgBanners: RgBanner[] }
export type UpsertRgBannerMutation = { upsertRgBanner: RgBanner }
export type UpsertRgBannerMutationVariables = { input: RgBannerInput }
export type ResetRgBannerMutation = { resetRgBanner: boolean }
export type ResetRgBannerMutationVariables = { countryCode: string }

const RG_BANNER_FIELDS = gql`
  fragment RgBannerFields on RgBanner {
    countryCode
    variant
    ageLabel
    messages
    rotateMessages
    shortMessage
    footer
    helpUrl
    helpPhone
    helpPhoneLabel
    regulatorUrl
    imageUrl
    enabled
    isTenantOverride
  }
`

export const GetRgBannerDocument = gql`
  ${RG_BANNER_FIELDS}
  query GetRgBanner($countryCode: String) {
    rgBanner(countryCode: $countryCode) {
      ...RgBannerFields
    }
  }
`

export const GetRgBannersDocument = gql`
  ${RG_BANNER_FIELDS}
  query GetRgBanners {
    rgBanners {
      ...RgBannerFields
    }
  }
`

export const UpsertRgBannerDocument = gql`
  ${RG_BANNER_FIELDS}
  mutation UpsertRgBanner($input: RgBannerInput!) {
    upsertRgBanner(input: $input) {
      ...RgBannerFields
    }
  }
`

export const ResetRgBannerDocument = gql`
  mutation ResetRgBanner($countryCode: String!) {
    resetRgBanner(countryCode: $countryCode)
  }
`
